import { Paper } from "@mui/material";

import HeroImage from "./HeroImage";
import HeroInfo from "./HeroInfo";
import HeroBanner from "./HeroBanner";

function HeroSection({ plant }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, md: 4 },
        borderRadius: 5,
        background: "rgba(255,255,255,.85)",
        backdropFilter: "blur(12px)",
        boxShadow: "0 15px 40px rgba(34,90,45,.12)",
        mb: 4,
      }}
    >
      <HeroImage plant={plant} />

      <HeroInfo plant={plant} />

      <HeroBanner />
    </Paper>
  );
}

export default HeroSection;